var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticStyle:{"padding-top":"20px"},attrs:{"separator":"/"}},_vm._l((_vm.list),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: item.path }}},[_vm._v(_vm._s(_vm.showName(item)))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-032a4cb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 82Qf
// module chunks = 1